import { render, staticRenderFns } from "./SysPositionModal.vue?vue&type=template&id=018b5ed8&scoped=true"
import script from "./SysPositionModal.vue?vue&type=script&lang=js"
export * from "./SysPositionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018b5ed8",
  null
  
)

export default component.exports